import axios from "axios";


export default axios.create({
    baseURL: "https://back-teste.vercel.app/"
})